import { AfterViewInit, Directive, ElementRef, forwardRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { ControlsConfigService } from '../../injection/controls-config.service';
import { Color, COLOR, NormalCircle } from '@seech/shared-ng';
import { ThemeColorDirective } from '../theme/theme.directive';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[sch-radio]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioDirective),
      multi: true,
    },
  ],
  hostDirectives: [
    {
      directive: ThemeColorDirective,
      inputs: ['color']
    }
  ]
})
export class RadioDirective implements AfterViewInit, OnChanges, OnInit, ControlValueAccessor {
  @Input({required: true}) id = '';
  @Input() color: Color = COLOR.PRIMARY;
  @Input() label = '';
  @Input() shape!: NormalCircle;
  @Input() highlightSelectedLabel = true;

  radioId!: string;

   
  private onChange = (value: boolean) => {};
   
  private onTouched = () => {};

  constructor(private configService: ControlsConfigService, 
              private elRef: ElementRef, 
              private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id']) {
      this.radioId = `radio-${this.id}`;
    }
  }

  ngOnInit(): void {
    if (!this.shape) {
      const config = this.configService.getConfig();
      this.shape = config?.radioButtonShape ? config.radioButtonShape : 'circle';
    }
  }

  ngAfterViewInit(): void {
    this.renderer.addClass(this.elRef.nativeElement, 'form-check');
    this.renderer.addClass(this.elRef.nativeElement, 'form-checkbox');
    this.renderer.addClass(this.elRef.nativeElement, 'seech-checkbox');

    const inputEl = this.elRef.nativeElement.querySelector('input');
    this.renderer.addClass(inputEl, 'form-check-input');
    this.renderer.addClass(inputEl, this.shape);
    this.renderer.setAttribute(inputEl, 'id', this.radioId);
    if(this.highlightSelectedLabel) {
      this.renderer.listen(inputEl, 'change', (event) => {
        const isChecked = event.target.checked;
        const inputEl = this.elRef.nativeElement.querySelector('label');
        isChecked ? this.renderer.addClass(inputEl, `text-${this.color}`)
        : this.renderer.removeClass(inputEl, `text-${this.color}`);
      });
    }
    
    if(this.label) {
      this.renderer.appendChild(this.elRef.nativeElement, this.labelEl);
    }
  }

  get labelEl(): HTMLElement {
    const label = this.renderer.createElement('label') as HTMLElement
    label.style.color = '#97A2B0';
    label.style.fontSize = '14px';
    label.style.paddingLeft = '5px';
    label.textContent = this.label;
    label.setAttribute('for', this.radioId);
    return label;
  }
  
  writeValue(value: boolean): void {
    const inputEl = this.elRef.nativeElement.querySelector('input');
    this.renderer.setProperty(inputEl, 'checked', value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}

